export { NgTranscludeDirective } from './common';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/minimal/index.js
// module id = 1382
// module chunks = 31